import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import {
  LocationTypeForMaster,
  Country,
  LocationType,
  Vehicle,
  PENDING_ACTION_TYPE,
  PENDING_ACTION_SUBTYPE,
  PANEL_MAIN_MENU_ITEMS,
  TIMEZONE,
  LocationSubType,
  LOCAL_STORAGE_KEYS,
} from './constants/values.constants';
import { isAllowedTo } from '../modules/permissions/permission.util';
import {
  REMOVE_DEALER_DROPDOWN,
  SHOW_TOUCH_POINT_DROPDOWN,
  SHOW_CORPORATE_OFFICE,
} from '../modules/permissions/permission.type';
import { toast } from 'react-toastify';

dayjs.extend(utc);
dayjs.extend(timezone);

export const countryCheck = localStorage.getItem('country');
export const vehicleCheck = localStorage.getItem('vehicleType');

export const getUserData = () => {
  return JSON.parse(localStorage.getItem('userData'));
};

export const getUserToken = () => {
  return localStorage.getItem('accessToken');
};

export const removeNewLines = (str) => {
  if (typeof str === 'string') {
    return str.trim().replaceAll('\n', ' ');
  }
  return str;
};

export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const convertObjectToParams = (params) => {
  if (typeof params === 'string') {
    return params;
  }
  let finalParams = '';
  Object.keys(params).forEach((key, index) => {
    if (index === 0) {
      finalParams += '?';
    }
    finalParams += key + '=' + params[key];
    if (index + 1 !== Object.keys(params).length) {
      finalParams += '&';
    }
  });
  return finalParams;
};

export const allCommonProperties = (objects) => {
  if (!objects.length) return {};

  let first = objects[0];

  let commonKeys = Object.keys(first).filter(function (p) {
    return objects.every(function (o) {
      return first[p] === o[p];
    });
  });

  let commonKeysWithValue = {};
  commonKeys.forEach((key) => (commonKeysWithValue[key] = first[key]));

  return commonKeysWithValue;
};

export const getDateFormateMMDDYYY = (dateString) => {
  const dateObj = dateString.split('/');
  const date = dateObj[0];
  dateObj[0] = dateObj[1];
  dateObj[1] = date;
  return dateObj.join('/');
};

export const tzDate = (date) => {
  let DATE = date ? new Date(date) : new Date();
  let TIMEZONE_DATE = DATE.toLocaleString('en-US', {
    timeZone: TIMEZONE[countryCheck],
  });
  return new Date(TIMEZONE_DATE);
};

export const customDateFormat = (date, separator = '-') => {
  if (!date) return '';

  let month = '' + (date.getMonth() + 1);
  let day = '' + date.getDate();
  let year = date.getFullYear();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;

  return [year, month, day].join(separator);
};

export const dateFormat = (e) => {
  let dateTime = tzDate(e);
  return dayjs(dateTime).format('YYYY-MM-DD');
};

export const timeFormat = (e) => {
  let newTime = tzDate(e);
  return dayjs(newTime).format('hh:mm A');
};

export const isValidTimeForSlot = () => {
  const startTime = tzDate().getTime();
  const endDate = tzDate();
  if (countryCheck === Country.AE) {
    endDate.setHours(22, 59, 59, 999);
  } else if (countryCheck === Country.KSA) {
    endDate.setHours(20, 59, 59, 999);
  } else if (countryCheck === Country.AU) {
    endDate.setHours(23, 59, 59, 999);
  } else {
    endDate.setHours(16, 59, 59, 999);
  }
  const endTime = endDate.getTime();

  return endTime >= startTime;
};

export const getFinalRanges = (
  startTime,
  endTime,
  difference,
  valTime = tzDate(),
  initialLeadTime
) => {
  let CurrentDate = tzDate();
  const isItSameDate =
    valTime?.getDate() === CurrentDate.getDate() &&
    valTime?.getMonth() === CurrentDate.getMonth();
  if (isItSameDate && !isValidTimeForSlot()) {
    return [];
  }

  let ranges = [];
  let finalRange = [];
  ranges = getRange(startTime, endTime, difference, [], initialLeadTime);

  let newDate = tzDate().getTime();
  let currentTime =
    valTime && valTime?.getDate() !== CurrentDate.getDate()
      ? new Date(newDate + difference * 60000)
      : new Date(newDate + initialLeadTime * 60000);

  const hour = currentTime.getHours();
  const minute = currentTime.getMinutes();
  const mins = Number(minute) > 10 ? minute : '0' + minute;

  let newTime = '';
  if (valTime === undefined) {
    newTime = hour + '.' + mins;
  } else if (!isItSameDate) {
    newTime = startTime;
  } else {
    newTime = hour + '.' + mins;
  }

  if (ranges && ranges.length) {
    ranges.forEach((element) => {
      let splitedElement = element.split('-')[0];
      if (
        parseFloat(splitedElement) >= parseFloat(newTime) ||
        countryCheck == Country.AU
      ) {
        finalRange.push(element.replace('.', ':'));
      }
    });
  }

  return finalRange;
};

export const getRange = (startTimeNew, endTime, difference, ranges) => {
  let rangeStart = startTimeNew;

  let rangeEnd = 0,
    startTimeSplit = startTimeNew.split('.'),
    minsPlusDifference = Number(startTimeSplit[1]) + Number(difference),
    timeArray = [],
    newHour = 0,
    newMins = 0;

  if (minsPlusDifference > 60) {
    if (difference > 60) {
      let newHoursToAdd = Math.floor(difference / 60);
      let minsAfterAddingHours =
        Number(startTimeSplit[1]) + (difference - 60 * newHoursToAdd);
      let minsAfterRemovingHours =
        Number(startTimeSplit[1]) - (difference - 60 * newHoursToAdd);
      newHour = Number(startTimeSplit[0]) + newHoursToAdd;
      newHour = minsAfterAddingHours >= 60 ? newHour + 1 : newHour;
      newMins =
        minsAfterAddingHours >= 60
          ? minsAfterRemovingHours
          : minsAfterAddingHours;
    } else {
      newHour = Number(startTimeSplit[0]) + 1;
      newMins = difference - (60 - startTimeSplit[1]);
    }
  } else if (minsPlusDifference === 60) {
    newHour = Number(startTimeSplit[0]) + 1;
    newMins = 0;
  } else {
    newHour = startTimeSplit[0];
    newMins = minsPlusDifference;
  }

  if (newMins < 10) {
    newMins = '0' + newMins;
  }
  if (newHour < 10) {
    newHour = '0' + newHour;
  }

  timeArray = [newHour, newMins];
  rangeEnd = timeArray.join('.');

  if (parseFloat(rangeEnd) <= parseFloat(endTime)) {
    ranges.push(rangeStart + '-' + rangeEnd);
    getRange(rangeEnd, endTime, difference, ranges);
  }

  return ranges;
};

export const IsAlphaNumeric = (alphane) => {
  var numaric = alphane;
  for (var j = 0; j < numaric.length; j++) {
    var alphaa = numaric.charAt(j);
    var hh = alphaa.charCodeAt(0);
    //eslint-disable-next-line no-empty
    if ((hh > 47 && hh < 58) || (hh > 64 && hh < 91) || (hh > 96 && hh < 123)) {
    } else {
      return false;
    }
  }

  return true;
};

export const IsAlphaNumericThai = (alphane) => {
  var numaric = alphane;
  let thaiUnicodeRegex = '^[\u0E00-\u0E7FA-Za-z0-9\\-]*$';
  let thaiCharacter = numaric.match(thaiUnicodeRegex);
  if (thaiCharacter) {
    return true;
  }
  return false;
};

var selectedValue = 0;

export const setActiveToggle = (selected) => {
  selectedValue = selected;
};

export const getActiveToggle = () => selectedValue;

export const redirectPage = () => {
  const allTabs = PANEL_MAIN_MENU_ITEMS.map((item) => item.path.substring(1));
  const currentTab = window.location.pathname.split('/')[1];

  if (allTabs.includes(currentTab)) {
    window.location = `/${currentTab}`;
  } else {
    window.location = '/';
  }
};

export const localStorageGroupData = () => {
  const userGroups = localStorage.getItem('user-groups');
  try {
    return userGroups ? JSON.parse(userGroups) : [];
  } catch (error) {
    console.error('Failed to parse user-groups from localStorage', error);
    return [];
  }
};

export const setLocationType = (locationType) => {
  if (locationType === 'CAR_STUDIO') {
    return locationType.replace('CAR_', '');
  }

  if (locationType === 'TOUCH_POINT') {
    return 'Loading Point';
  }

  return (locationType && locationType.replace(/_/g, ' ')) || '-';
};

export const isObjectEmpty = (dataObject) =>
  Object.keys(dataObject).length === 0;

export const getLogisticSearchRequestParams = (searchParams) => {
  const requestParams = new URLSearchParams(searchParams);
  requestParams.append('sort', 'mv.logistic.requestedPickupTime');
  requestParams.append('mv.logistic.requestedPickupTime.dir', 'asc');
  requestParams.append('sort', 'mv.logistic.pickUpSlotFrom');
  requestParams.append('mv.logistic.pickUpSlotFrom.dir', 'asc');
  requestParams.append('sort', 'mv.logistic.pickUpSlotTo');
  requestParams.append('mv.logistic.pickUpSlotTo.dir', 'asc');
  return '?' + requestParams.toString();
};

export const getCitiesOfSameState = (cityCode, CITIES_GROUP) => {
  for (let state of Object.keys(CITIES_GROUP)) {
    if (CITIES_GROUP[state].includes(cityCode)) {
      return CITIES_GROUP[state];
    }
  }
  return [cityCode];
};

// Location type list for location master
export const getLocationTypesForMaster = () => {
  let locationTypeList = Object.assign({}, LocationTypeForMaster);

  if (isAllowedTo(REMOVE_DEALER_DROPDOWN)) {
    delete locationTypeList.DEALER;
  }

  if (!isAllowedTo(SHOW_CORPORATE_OFFICE)) {
    delete locationTypeList.CORPORATE_OFFICE;
  }

  if (!isAllowedTo(SHOW_TOUCH_POINT_DROPDOWN)) {
    delete locationTypeList.TOUCH_POINT;
  }

  return locationTypeList;
};

// Location type list for barcode mobile view
export const getLocationTypesForBarCode = () => {
  let locationTypeList = Object.assign({}, LocationType);

  if (isAllowedTo(REMOVE_DEALER_DROPDOWN)) {
    delete locationTypeList.DEALER;
  }

  return locationTypeList;
};

export const formatDateTime = (dateTime) => {
  if (!dateTime) {
    return '';
  }
  return dayjs(dateTime)
    .tz(TIMEZONE[countryCheck])
    .format('YYYY-MM-DD hh:mm A');
};

export const isInCarVertical = () => {
  const country = localStorage.getItem('country');
  const vehicle = localStorage.getItem('vehicleType');

  return (
    !!country && country === Country.IN && !!vehicle && vehicle === Vehicle.CAR
  );
};

export const saveToLocalStorage = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (err) {
    console.log(err);
  }
};

export const getFromLocalStorage = (key) => {
  let val = localStorage.getItem(key);
  try {
    if (val) return JSON.parse(val);
  } catch (err) {
    return null;
  }
  return val;
};

export const removeFromLocalStorage = (key) => {
  localStorage.removeItem(key);
};

export const showToastMessage = (
  message,
  isSuccess = true,
  autoClose = 3000
) => {
  if (isSuccess) {
    toast.success(message, {
      hideProgressBar: true,
      autoClose: autoClose,
    });
  } else {
    toast.error(message, {
      hideProgressBar: true,
      autoClose: autoClose,
      closeOnClick: true,
    });
  }
};

export const GetQueryString = (field) => {
  var href = window.location.href;
  var reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
  var string = reg.exec(href);
  return string ? string[1] : null;
};

export const isNullish = (obj) => {
  return Object.values(obj).every((value) => {
    if (value === null) {
      return true;
    }
    return false;
  });
};

export const getUIValue = (value, fieldClicked) => {
  switch (fieldClicked) {
    default:
      return value ? value : '-';
  }
};

export const delistingReasonUiValue = (type, subType) => {
  if (type === PENDING_ACTION_TYPE.PUBLISH_STATUS_UPDATE) {
    if (subType === PENDING_ACTION_SUBTYPE.UNPUBLISH) {
      return 'Temporary';
    }
    if (subType === PENDING_ACTION_SUBTYPE.PERMANENT_DELISTING) {
      return 'Permanent';
    }
  }
};

export const pendingActionTypeUiValue = (type, subType) => {
  switch (type) {
    case PENDING_ACTION_TYPE.OFFER_PRICE_UPDATE: {
      return 'Offer Price';
    }
    case PENDING_ACTION_TYPE.LISTING_PRICE_UPDATE: {
      if (subType === PENDING_ACTION_SUBTYPE.PRICE_REVISION)
        return 'Price Revision';
      if (subType === PENDING_ACTION_SUBTYPE.INITIAL_PRICE_UPDATE)
        return 'Listing Price';
      break;
    }
    case PENDING_ACTION_TYPE.PUBLISH_STATUS_UPDATE: {
      if (
        subType === PENDING_ACTION_SUBTYPE.UNPUBLISH ||
        subType === PENDING_ACTION_SUBTYPE.PERMANENT_DELISTING
      )
        return 'Delisting';
      if (subType === PENDING_ACTION_SUBTYPE.PUBLISH) return 'Relisting';
    }
  }
};

export const getUpdatedBy = (updatedBy) => {
  const { uid, authType } = updatedBy;
  if (authType === 'USER') return uid;

  const { initiatedBy, initiatedFrom } = updatedBy;

  if (!initiatedFrom) {
    return initiatedBy || uid;
  } else {
    return `${initiatedBy || updatedBy.uid} (via ${initiatedFrom})`;
  }
};

export const getLocationType = (location) => {
  switch (location?.locationSubType) {
    case LocationSubType.DLT:
      return LocationSubType.DLT;
    case LocationSubType.EXTERNAL_VENDOR:
      return LocationSubType.EXTERNAL_VENDOR;
    default:
      return location.locationType;
  }
};

export const slideToggle = () => {
  const x = document.getElementById('Search');
  if (x.style.display === 'none') {
    x.style.display = 'block';
    document.getElementById('searchBtn').classList.add('show');
    // document.getElementById("searchBtn").classList.remove("hide");
  } else {
    x.style.display = 'none';
    // document.getElementById("searchBtn").classList.add("hide");
    document.getElementById('searchBtn').classList.remove('show');
  }
};

export const filterMasterDataConfig = (config) => {
  const currentVertical = `${countryCheck}:${vehicleCheck}`.toUpperCase();
  const filteredConfig = {};

  Object.keys(config).forEach((entity) => {
    if (
      !config[entity].rules.verticals ||
      config[entity].rules?.verticals?.includes(currentVertical)
    ) {
      filteredConfig[entity] = config[entity];
    }
  });

  return filteredConfig;
};

export const getLogisticProviderLabel = (
  logisticProviders = [],
  providerType,
  providerSubType
) => {
  return logisticProviders.find(
    (provider) =>
      provider.providerType === providerType &&
      provider.providerSubType === providerSubType
  )?.label;
};

export const stockInText = (() =>
  countryCheck === Country.AU ? 'Park' : 'Stock In')();

export const removeFuzzySearch = (params) => {
  let updatedParams = {};

  for (let key in params) {
    if (typeof params[key] === 'string') {
      updatedParams[key] = params[key].replaceAll('%25', '');
    }
  }
  return updatedParams;
};

export const createSelectedInventoryObject = (invt) => {
  let {
    allowedActions: {
      CREATE_MOVEMENT,
      CREATE_LOGISTIC,
      TRIP_START,
      TRIP_END,
      SEND_NOTIFICATION,
    },
    inventory: { appointmentId, locationCode, lastLocationCode, status },
    inventoryMovement,
    movementActive,
  } = invt;
  let {
    complete,
    toLocationCode,
    externalDelivery,
    externalMovement,
    externalPickup,
    logistic,
  } = inventoryMovement || {};

  let selectedInventory = {
    CREATE_MOVEMENT,
    CREATE_LOGISTIC: CREATE_LOGISTIC && complete,
    TRIP_START,
    TRIP_END,
    appointmentId,
    status,
    locationCode,
    lastLocationCode,
    toLocationCode,
    movementActive,
    logisticVendorEmail: logistic?.driverEmail || null,
    logisticPickupDate: logistic?.requestedPickupTime,
    isInternalMovement:
      !externalDelivery || !externalMovement || !externalPickup,
    SEND_NOTIFICATION,
    __inventory: invt,
  };
  return selectedInventory;
};

export const formatSlotKey = (slotKey) => {
  if (!slotKey) return '';
  let elts = slotKey.split('_');
  let from = elts[0].substring(0, 2) + ':' + elts[0].substring(2);
  let to = elts[1].substring(0, 2) + ':' + elts[1].substring(2);
  let imsSlot = from + '-' + to;
  return imsSlot;
};

export const getInventorySubStages = (
  inventoryStages = [],
  currentInventoryStage
) => {
  const currentInventoryStageObj = inventoryStages.filter(
    (invStage) => invStage.reason === currentInventoryStage
  );
  return currentInventoryStageObj?.[0]?.inventorySubStages || [];
};

export const accountId = (function () {
  const country = localStorage.getItem('country');
  const vehicle = localStorage.getItem('vehicleType');
  return `${country}_${vehicle}`;
})();

export const createTimeRange = (from, to, separator, intervals) => {
  const timeRange = [];

  for (let i = from; i <= to; i++) {
    for (let j = 0; j < intervals.length; j++) {
      let time = `${i}${separator}${intervals[j]}`;
      if (i < 10) {
        time = `0${time}`;
      }
      timeRange.push(time);
    }
  }
  timeRange.pop();
  return timeRange;
};

export const dashifyYYYYMMDD = (date) => {
  return date.toString().replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3');
};

export const isEmailVendorApplicable = ({ inventoryDetail }) => {
  let {
    allowedActions: { SEND_NOTIFICATION },
    inventoryMovement,
    inventory: { locationCode },
  } = inventoryDetail;
  let { externalDelivery, externalMovement, externalPickup, logistic } =
    inventoryMovement || {};

  let isInternalMovement =
    !externalDelivery || !externalMovement || !externalPickup;

  return (
    isInternalMovement &&
    locationCode &&
    logistic?.driverEmail != null &&
    logistic?.requestedPickupTime &&
    SEND_NOTIFICATION
  );
};

export const getLocationField = (locationObject, fieldName) => {
  return locationObject?.[fieldName] || false;
};

export const getExternalLocationField = (
  externalLocation,
  addressType,
  fieldName
) => {
  return (
    (externalLocation?.addressType === addressType &&
      externalLocation?.location[fieldName]) ||
    false
  );
};

export const copyToClipboard = (textToCopy) => {
  navigator.clipboard.writeText(textToCopy).catch((e) => console.error(e));
};

export const convertTime12to24 = (from, suffix, to, toSuffix) => {
  let fromSlot = null;
  let toSlot = null;
  if (from && to) {
    if (from && suffix.toLowerCase().indexOf('am') !== -1) {
      fromSlot = parseInt(from);
    } else if (from && suffix.toLowerCase().indexOf('pm') !== -1) {
      fromSlot = (parseInt(from) % 12) + 12;
    }

    if (to && toSuffix.toLowerCase().indexOf('pm') !== -1) {
      toSlot = (parseInt(to) % 12) + 12;
    } else if (to && toSuffix.toLowerCase().indexOf('am') !== -1) {
      toSlot = parseInt(to);
    }

    return `${fromSlot}:00-${toSlot}:00`;
  } else {
    return false;
  }
};

export const userHasGroup = (groups = []) => {
  let userGroups = getFromLocalStorage(LOCAL_STORAGE_KEYS.USER_GROUPS);
  return userGroups?.some((group) => groups.includes(group));
};

export const getInitialSearchParams = (localStorageKey) => {
  let searchParams = {};
  let _searchParams = localStorage.getItem(localStorageKey);
  if (_searchParams) {
    searchParams = JSON.parse(_searchParams);
  }
  return searchParams;
};

export const parseFastagErrResponse = (err) => {
  const errorData = err.response.data;
  return {
    ...errorData,
    message: errorData.description || errorData.validation,
  };
};

const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
